<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const delayLabel = computed(() => {
  const mins = props.data.delay_minutes;
  if (!mins) return t('FLOW_BUILDER.NODES.DELAY.CONFIGURE');
  if (mins % 1440 === 0) return t('FLOW_BUILDER.NODES.DELAY.DAYS', mins / 1440);
  if (mins % 60 === 0) return t('FLOW_BUILDER.NODES.DELAY.HOURS', mins / 60);
  return t('FLOW_BUILDER.NODES.DELAY.MINUTES', mins);
});
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-slate-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-slate-500 text-white">
      <span class="i-lucide-clock size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.DELAY.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      {{ delayLabel }}
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
